(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["supermen-gave-kurv"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.SupermenGaveKurv) return;
    window.SupermenGaveKurv = true;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var koe = Promise.resolve(), venter = 0;

    function knapper() { return Array.prototype.slice.call(document.querySelectorAll('[data-spd-gave-linje]')); }
    function noegle() { var k = knapper()[0]; return (k && k.dataset.noegle) || 'giftwrap'; }
    function navn(it) { return it.title || it.product_title; }
    function titler(cart, n) {
      var v = String((cart.attributes || {})[n] || ''), t = [], m;
      var re = /\s*(.+?) \(x\d+\)\s*(?:,|$)/g;
      while ((m = re.exec(v))) if (t.indexOf(m[1]) < 0) t.push(m[1]);
      if (!t.length && v.trim()) v.split(',').forEach(function (d) { d = d.trim(); if (d && t.indexOf(d) < 0) t.push(d); });
      return t;
    }
    function gem(cart, n, liste) {
      var tekst = cart.items.filter(function (it) { return liste.indexOf(navn(it)) > -1; })
        .map(function (it) { return navn(it) + ' (x' + it.quantity + ')'; }).join(', ');
      if (tekst === String((cart.attributes || {})[n] || '')) return Promise.resolve(cart);
      var a = {};
      a[n] = tekst;
      return fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: a })
      }).then(function (r) { if (!r.ok) throw new Error('giftwrap'); return r.json(); });
    }
    function hent() {
      return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
    }
    function saet(k, paa) { k.setAttribute('aria-pressed', paa ? 'true' : 'false'); }
    function vis(cart, n) {
      var liste = titler(cart, n);
      knapper().forEach(function (k) { saet(k, liste.indexOf(k.dataset.titel) > -1); });
    }
    function valgt(titel) {
      return knapper().some(function (k) { return k.dataset.titel === titel && k.getAttribute('aria-pressed') === 'true'; });
    }
    // Gemmer ét valg ad gangen, så hurtige klik på flere varer ikke overskriver hinanden.
    // Går det galt, vises det, der faktisk ligger i kurven.
    function iKoe(job, n) {
      venter++;
      koe = koe.then(job).then(function (cart) {
        if (venter === 1 && cart) vis(cart, n);
      }, function () {
        return hent().then(function (cart) { if (venter === 1) vis(cart, n); }).catch(function () {});
      }).then(function () { venter--; });
    }

    // Knappen skifter med det samme; gemningen sker bagefter
    document.addEventListener('click', function (e) {
      var k = e.target.closest && e.target.closest('[data-spd-gave-linje]');
      if (!k) return;
      var n = k.dataset.noegle || 'giftwrap', titel = k.dataset.titel, paa = k.getAttribute('aria-pressed') !== 'true';
      knapper().forEach(function (x) { if (x.dataset.titel === titel) saet(x, paa); });
      k.classList.remove('is-pop');
      if (paa) { void k.offsetWidth; k.classList.add('is-pop'); }
      iKoe(function () {
        return hent().then(function (cart) {
          var liste = titler(cart, n), i = liste.indexOf(titel), nu = valgt(titel);
          if (nu && i < 0) liste.push(titel);
          if (!nu && i > -1) liste.splice(i, 1);
          return gem(cart, n, liste);
        });
      }, n);
    });

    // Antal ændret eller vare fjernet på kurvsiden: "(x2)" i feltet følger med
    document.addEventListener('cart:update', function (e) {
      if (!knapper().length) return;
      var n = noegle(), c = e.detail && e.detail.resource;
      iKoe(function () {
        return (c && c.items && c.attributes && venter === 1 ? Promise.resolve(c) : hent()).then(function (cart) {
          return gem(cart, n, titler(cart, n));
        });
      }, n);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["supermen-kort"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.SupermenKortStr) return;
    window.SupermenKortStr = true;
    // Baren under billederne følger med, når man swiper
    document.addEventListener('scroll', function (e) {
      var l = e.target;
      if (!l.classList || !l.classList.contains('spd-kort__link--glid')) return;
      var bar = l.parentNode.querySelector('.spd-kort__bar');
      if (bar && l.clientWidth) bar.style.setProperty('--i', Math.round(l.scrollLeft / l.clientWidth));
    }, { capture: true, passive: true });
    // Størrelserne ligger gemt bag pilen nederst på billedet, så varen kan ses i ro
    function aabn(kort, vis, fokus) {
      if (!kort) return;
      var knap = kort.querySelector('[data-spd-aabn]');
      kort.classList.toggle('is-str', vis);
      if (knap) knap.setAttribute('aria-expanded', vis ? 'true' : 'false');
      if (!fokus) return;
      if (vis) { var f = kort.querySelector('.spd-kort__str button:not([disabled])'); if (f) f.focus({ preventScroll: true }); }
      else if (knap) knap.focus({ preventScroll: true });
    }
    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      // Fokus flyttes kun ved tastatur (detail 0), så en række ikke ruller væk under musen
      var a = e.target.closest('[data-spd-aabn]');
      if (a) { e.preventDefault(); aabn(a.closest('.spd-kort'), true, e.detail === 0); return; }
      var l = e.target.closest('[data-spd-luk]');
      if (l) { e.preventDefault(); aabn(l.closest('.spd-kort'), false, e.detail === 0); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !e.target.closest) return;
      var kort = e.target.closest('.spd-kort.is-str');
      if (kort) { e.preventDefault(); aabn(kort, false, true); }
    });
    // Lukker igen, når musen eller fokus forlader kortet
    document.addEventListener('mouseout', function (e) {
      // Ikke mens en knap holdes nede: rækkerne fanger musen, når man trækker i dem
      if (e.buttons) return;
      var kort = e.target.closest && e.target.closest('.spd-kort.is-str');
      if (!kort || (e.relatedTarget && kort.contains(e.relatedTarget))) return;
      var tast = document.activeElement && kort.contains(document.activeElement) && document.activeElement.matches(':focus-visible');
      if (tast) return;
      setTimeout(function () { if (!kort.matches(':hover')) aabn(kort, false, false); }, 200);
    });
    document.addEventListener('focusout', function (e) {
      var kort = e.target.closest && e.target.closest('.spd-kort.is-str');
      if (kort && e.relatedTarget && !kort.contains(e.relatedTarget)) aabn(kort, false, false);
    });
    // Størrelsen vælges først; knappen "Læg i kurv" får så varianten og lægger den i kurven
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.spd-kort__hurtig [data-spd-valg]');
      if (!b || b.disabled) return;
      e.preventDefault();
      var g = b.closest('.spd-kort__hurtig');
      Array.prototype.forEach.call(g.querySelectorAll('[data-spd-valg]'), function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      var knap = g.querySelector('.spd-kort__laeg');
      knap.dataset.spdAdd = b.dataset.spdValg;
      knap.dataset.spdValgNavn = b.textContent.trim();
      knap.disabled = false;
      knap.classList.remove('is-ok');
      knap.setAttribute('aria-label', 'Læg ' + (g.dataset.navn || '') + ', ' + b.textContent.trim() + ' i kurven');
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["supermen-spor"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.SupermenSpor) return;
    window.SupermenSpor = true;
    var roligt = window.matchMedia('(prefers-reduced-motion: reduce)');

    function maal(root) {
      var spor = root.querySelector('[data-sp-spor]'), nav = root.querySelector('[data-sp-nav]'), maaler = root.querySelector('[data-sp-maaler]');
      if (!spor) return;
      var ruller = spor.scrollWidth > spor.clientWidth + 2;
      if (nav) nav.hidden = !ruller;
      if (maaler) maaler.hidden = !ruller;
      if (!ruller) return;
      var max = spor.scrollWidth - spor.clientWidth;
      var x = Math.max(0, Math.min(spor.scrollLeft, max));
      if (nav) {
        nav.querySelector('[data-sp-dir="-1"]').disabled = x <= 2;
        nav.querySelector('[data-sp-dir="1"]').disabled = x >= max - 2;
      }
      if (maaler) {
        var s = spor.clientWidth / spor.scrollWidth;
        var t = maaler.querySelector('[data-sp-tommel]');
        t.style.setProperty('--sp-s', s.toFixed(4));
        t.style.setProperty('--sp-x', ((x / max) * (1 - s) * 100).toFixed(2) + '%');
      }
    }
    // Et klik flytter rækken så mange hele kort, som der er plads til
    function skridt(spor) {
      var el = spor.firstElementChild;
      if (!el) return spor.clientWidth;
      var gap = parseFloat(window.getComputedStyle(spor).columnGap) || 0;
      var w = el.getBoundingClientRect().width + gap;
      return Math.max(1, Math.floor((spor.clientWidth + gap) / w)) * w;
    }
    function init(scope) {
      Array.prototype.forEach.call((scope || document).querySelectorAll('[data-sp]'), function (root) {
        if (root._sp) { maal(root); return; }
        var spor = root.querySelector('[data-sp-spor]');
        if (!spor) return;
        root._sp = true;
        var t = 0;
        spor.addEventListener('scroll', function () {
          if (t) return;
          t = window.requestAnimationFrame(function () { t = 0; maal(root); });
        }, { passive: true });
        if ('ResizeObserver' in window) new window.ResizeObserver(function () { maal(root); }).observe(spor);
        maal(root);
      });
    }
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-sp-dir]');
      if (!b) return;
      var root = b.closest('[data-sp]'), spor = root && root.querySelector('[data-sp-spor]');
      if (!spor) return;
      spor.scrollBy({ left: skridt(spor) * parseInt(b.dataset.spDir, 10), behavior: roligt.matches ? 'auto' : 'smooth' });
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();
  } catch(e) { console.error(e); }
})();

})();
